import BaseApi from './BaseApi';

/**
 * 既読日時更新用パラメータ
 */
export type UpdateLastReadTimeParam = {
  /**
   * Lineユーザかどうか
   */
  isLineUser: boolean;

  /**
   * 会員ID
   */
  companyId: string;

  /**
   * usermatch更新用のキー（チャネルで一意）
   */
  matchId: string;
};

/**
 * userMatch関係の更新/取得API
 */
class UserMatchApi extends BaseApi {
  async updateLastReadTimestamp(params: UpdateLastReadTimeParam) {
    return await this.execute('updateLastReadTimeApi', {
      method: 'POST',
      body: params
    }).then(({ status }) => {
      status === 1;
    });
  }
  async getLastReadTimestamp(params: UpdateLastReadTimeParam) {
    return await this.execute('getLastReadTimeApi', {
      method: 'POST',
      body: params
    }).then(({ result }) => {
      let lastReadTimestamp = 0;
      if (result.lastReadTimestamp) {
        lastReadTimestamp = result.lastReadTimestamp;
      }
      return lastReadTimestamp;
    });
  }
}

export default UserMatchApi;
